<template>
  <div class="set-title">
    <el-dialog
        title="一键下单"
        :visible="visible"
        @close="handleClose"
        width="660px"
    >
      <div class="box">
        <div class="left">
          <img :src="info.picUrl" alt="">
        </div>
        <div class="right">
          <p>{{ info.goodsName }}</p>
          <div v-for="(item, index) in info.specificationList" :key="index">
            <div class="" style="display: flex;">
              <div style="margin-top: 5px;">{{item.name}}：</div>
              <div style="display: flex;align-items: center;flex-wrap: wrap;flex: 1;">
                <div
                    v-for="(v,i) in item.value"
                    :key="`${index}-${i}`"
                >
                        <!--:class="v.checked === '1' ? 'text active' : 'text'"-->
                    <div
                        :class="isChecked(item,v)"
                        @click="handleGG(item, v, i)"
                    >{{v.name}}</div>
                  </div>
                <!--</div>-->
              </div>
            </div>
          </div>
          <p style="margin-top: 5px;">价格：
            {{info.money}}</p>
          <p style="margin-top: 5px;">数量：
            <el-input-number
                v-model="row.goodsCount"
                :min="1"
                size="small"
                :max="9999999999"
                :controls="false"
                label="数量"
            >
            </el-input-number>
          </p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="handleClose">取 消</el-button>
        <el-button :loading="loading" class="form-btn btn-blue" @click="doConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "orders",
  data(){
    return{
      visible: false,
      info: {},
      loading: false,
      row:{},
      index: 0,
      currentSpStr:""
    }
  },
  computed: {
    // 获取规格列表
    isChecked () {
      return (item, v) => {
        if (v == undefined) {
          return ''
        }
        if (this.currentSpStr) {
          const targetStr = `${item?.name}:${v?.name}`;
          let spec = this.currentSpStr.split(";")
          for (let i = 0; i < spec.length; i++) {
            if (spec[i] === targetStr){
              v.checked = 1
              v.newName = targetStr
              return 'text active';
            }
          }
          return 'text';
        } else {
          return v.checked === '1' ? 'text active' : 'text';
        }
      }
    }
  },
  methods: {
    // 点击规格(非图片)
    handleGG (item, v) {
      this.currentSpStr = ''
      item.value = item.value.map((c) => {
        if (c.name === v.name) {
          c.checked = '1'
          c.newName = item.name + ':' + v.name
        } else {
          c.checked = '0'
          c.newName = ''
        }
        return { ...c }
      })
      this.screenItem()
    },
    // 筛选选择商品
    screenItem(){
      let data = this.info.specificationList
          .map((v) => {
            return v.value
          })
          .flat()
          .filter((c) => {
            return c.newName
          })
          .map((b) => {
            return b.newName
          })
      //没有选中规格
      let isSelect = false;
      this.info.attrPriceList.forEach((v) => {
        if (data.length === this.info.specificationList.length) {
          if (this.isArrayEqual(data, v.sp_data.split(';'))) {
            console.log(v)
            this.info.productInfo = v
            this.info.money = v.price || this.info.price
            this.info.taotianGoodsSkuId = v.taotianGoodsSkuId
            // initialUnitPrice.value = v.price
            isSelect = true
          }
        }
      })
      if (!isSelect) {
        this.info.productInfo.specId = ""
      }
    },
    // 判断数组内容相同不考虑顺序
    isArrayEqual(arr1, arr2) {
      // 解析规格为统一的键值对对象（解决格式不一致问题）
      const parseSpecs = (specInput) => {
        const specObj = {};
        const specArray = Array.isArray(specInput) ? specInput : [specInput];

        specArray.forEach(item => {
          const parts = item.split(';');
          parts.forEach(part => {
            const trimPart = part.trim();
            if (!trimPart) return;

            if (trimPart.includes(':')) {
              const [key, value] = trimPart.split(':', 2);
              specObj[key.trim()] = value.trim();
            } else {
              specObj[trimPart] = true;
            }
          });
        });
        return specObj;
      };

      // 解析两个数组
      const obj1 = parseSpecs(arr1);
      const obj2 = parseSpecs(arr2);

      // 对比两个对象（不考虑顺序）
      const keys1 = Object.keys(obj1).sort();
      const keys2 = Object.keys(obj2).sort();

      if (keys1.length !== keys2.length) return false;

      for (let i = 0; i < keys1.length; i++) {
        const key = keys1[i];
        if (key !== keys2[i] || obj1[key] !== obj2[key]) {
          return false;
        }
      }

      return true;
    },
    async getInfo(row,index){
      this.visible = true
      this.row = row
      this.index = index
      const params = {url: this.row.taobaoUrl}
      const res = await this.$http.get("shop/1688/goods/getGoodsInfo", {params})
      this.info = res.data.data
      if (this.row.specId != "" && this.row.specId != null){
        this.info.productInfo = {
          specId: this.row.specId
        }
        for (let i = 0; i < this.info.attrPriceList.length; i++) {
          if (this.row.specId == this.info.attrPriceList[i].specId) {
            this.currentSpStr = this.info.attrPriceList[i].sp_data
            this.info.money = this.info.attrPriceList[i].price
          }
        }
      }
    },
    async doConfirm(){
      this.loading = true
      try {
        let queryInfo = {
          id:this.row.id,
          offerId:this.info.code,
          sellerOpenId:this.info.sellerOpenId,
          specId:this.info?.productInfo?.specId,
          customerUserId:this.row.userId
        }
        const res = await this.$http.get('shop/1688/goods/goodsListByUser',{ params: queryInfo })
        if(res.data.code === 200){
          this.loading = false
          if(res.data.data?.length > 0){
            let orderIdList = res.data.data.map(item => item.id)
            this.$confirm("订单号：【" + orderIdList.join('】,【') + "】商品信息与当前商品一致，是否继续？",  {
              confirmButtonText: "是",
              confirmButtonClass: "form-btn btn-blue",
              cancelButtonText: "否",
              cancelButtonClass: "form-btn btn-gray",
              type: "warning"
            }).then(async () => {
              this.updateSpec();
            }).catch(() => {});
          }else{
            this.updateSpec();
          }
        }
      }finally {
        console.log("finally")
      }
    },
    updateSpec(){
      this.row.offerId = this.info.code
      this.row.sellerOpenId = this.info.sellerOpenId
      this.row.specId = this.info?.productInfo?.specId
      this.row.orderId = this.row.id
      this.row.customerUserId = this.row.userId
      this.$http.post("shop/1688/goods/updateSpec", this.row).then((res) => {
        if (res.data.code === 200) {
          this.$emit('confirm',this.row,this.index)
        }
        this.visible = false
      });
    },
    handleClose () {
      this.visible = false
    }
  }
}
</script>

<style scoped lang="less">
.box{
  display: flex;
  img{
    width: 160px;
    height: 160px;
  }
  .right{
    margin-left: 15px;
    .title{
      font-size: 17px;
      margin: 5px 0;
    }
    .img1{
      width: 50px;
      height: 50px;
      margin-right: 5px;
      margin-bottom: 5px;
      cursor: pointer;
      border-radius: 5px;
      border: 2px solid #fff;
      &.active {
        border-radius: 5px;
        border: 2px solid #ff8726;
      }
    }
    .text{
      padding: 3px 6px;
      cursor: pointer;
      border-radius: 5px;
      border: 2px solid #fff;
      &.active {
        border-radius: 5px;
        border: 2px solid #ff8726;
      }
    }
  }
}
.flex{
  display: flex;
  align-items: center;
  margin-top: 10px;
  p{
    width: 75px;
  }
  .el-input{
    flex: 1;
  }
  .el-select{
    flex: 1;
  }
}

.set-title {
  ::v-deep .el-dialog__header {
    text-align: center;
  }
  ::v-deep .vue-barcode-element{
    width: 100%!important;
  }
  ::v-deep .el-dialog__body{
    padding-top: 10px;
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ::v-deep .el-input-number--medium {
    width: 100%;
  }
  ::v-deep .el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
}
</style>
